// client/src/data/colleges.js

const colleges = [
  // ⭐ Always first
  {
    name: "Kalinga Institute of Industrial Technology (KIIT University)",
    city: "Bhubaneswar",
    state: "Odisha",
    country: "India",
    lat: 20.355,
    lon: 85.819
  },

  // 🇮🇳 India — Top Universities with locations
  { name: "Indian Institute of Technology Bombay (IIT Bombay)", city: "Mumbai", state: "Maharashtra", country: "India" },
  { name: "Indian Institute of Technology Delhi (IIT Delhi)", city: "New Delhi", state: "Delhi", country: "India" },
  { name: "Indian Institute of Technology Madras (IIT Madras)", city: "Chennai", state: "Tamil Nadu", country: "India" },
  { name: "Indian Institute of Technology Kanpur (IIT Kanpur)", city: "Kanpur", state: "Uttar Pradesh", country: "India" },
  { name: "Indian Institute of Technology Kharagpur (IIT Kharagpur)", city: "Kharagpur", state: "West Bengal", country: "India" },
  { name: "Indian Institute of Technology Roorkee (IIT Roorkee)", city: "Roorkee", state: "Uttarakhand", country: "India" },
  { name: "Indian Institute of Technology Guwahati (IIT Guwahati)", city: "Guwahati", state: "Assam", country: "India" },
  { name: "Indian Institute of Technology Hyderabad (IIT Hyderabad)", city: "Hyderabad", state: "Telangana", country: "India" },
  { name: "IIT Indore", city: "Indore", state: "Madhya Pradesh", country: "India" },
  { name: "Indian Institute of Science (IISc)", city: "Bangalore", state: "Karnataka", country: "India" },

  { name: "National Institute of Technology Trichy (NIT Trichy)", city: "Tiruchirappalli", state: "Tamil Nadu", country: "India" },
  { name: "NIT Rourkela", city: "Rourkela", state: "Odisha", country: "India" },
  { name: "NIT Surathkal", city: "Mangalore", state: "Karnataka", country: "India" },
  { name: "NIT Warangal", city: "Warangal", state: "Telangana", country: "India" },

  { name: "BITS Pilani", city: "Pilani", state: "Rajasthan", country: "India" },
  { name: "Delhi University", city: "New Delhi", state: "Delhi", country: "India" },
  { name: "University of Calcutta", city: "Kolkata", state: "West Bengal", country: "India" },
  { name: "Savitribai Phule Pune University", city: "Pune", state: "Maharashtra", country: "India" },
  { name: "Anna University", city: "Chennai", state: "Tamil Nadu", country: "India" },
  { name: "Jadavpur University", city: "Kolkata", state: "West Bengal", country: "India" },

  { name: "Vellore Institute of Technology (VIT)", city: "Vellore", state: "Tamil Nadu", country: "India" },
  { name: "SRM Institute of Science and Technology", city: "Chennai", state: "Tamil Nadu", country: "India" },
  { name: "Amity University", city: "Noida", state: "Uttar Pradesh", country: "India" },
  { name: "Chandigarh University", city: "Mohali", state: "Punjab", country: "India" },
  { name: "Manipal Academy of Higher Education (MAHE)", city: "Manipal", state: "Karnataka", country: "India" },
  { name: "Thapar Institute of Engineering and Technology", city: "Patiala", state: "Punjab", country: "India" },

  { name: "Jamia Millia Islamia", city: "New Delhi", state: "Delhi", country: "India" },
  { name: "Jawaharlal Nehru University (JNU)", city: "New Delhi", state: "Delhi", country: "India" },
  { name: "Banaras Hindu University (BHU)", city: "Varanasi", state: "Uttar Pradesh", country: "India" },
  { name: "Osmania University", city: "Hyderabad", state: "Telangana", country: "India" },
  { name: "Aligarh Muslim University (AMU)", city: "Aligarh", state: "Uttar Pradesh", country: "India" },
  { name: "Punjab University", city: "Chandigarh", state: "Chandigarh", country: "India" },
  { name: "Ahmedabad University", city: "Ahmedabad", state: "Gujarat", country: "India" },
  { name: "HBTU Kanpur", city: "Kanpur", state: "Uttar Pradesh", country: "India" },

  // 🌍 World Universities (selected with locations)
  { name: "Massachusetts Institute of Technology (MIT)", city: "Cambridge", state: "Massachusetts", country: "USA" },
  { name: "Harvard University", city: "Cambridge", state: "Massachusetts", country: "USA" },
  { name: "Stanford University", city: "Stanford", state: "California", country: "USA" },
  { name: "University of Oxford", city: "Oxford", state: "England", country: "UK" },
  { name: "University of Cambridge", city: "Cambridge", state: "England", country: "UK" },
  { name: "California Institute of Technology (Caltech)", city: "Pasadena", state: "California", country: "USA" },
  { name: "ETH Zurich", city: "Zurich", state: "Zurich", country: "Switzerland" },
  { name: "Princeton University", city: "Princeton", state: "New Jersey", country: "USA" },
  { name: "Yale University", city: "New Haven", state: "Connecticut", country: "USA" },
  { name: "University of Chicago", city: "Chicago", state: "Illinois", country: "USA" },
  { name: "University of Toronto", city: "Toronto", state: "Ontario", country: "Canada" },
  { name: "Carnegie Mellon University", city: "Pittsburgh", state: "Pennsylvania", country: "USA" },
  { name: "National University of Singapore (NUS)", city: "Singapore", state: "-", country: "Singapore" },
  { name: "Seoul National University", city: "Seoul", state: "-", country: "South Korea" },
  { name: "Tsinghua University", city: "Beijing", state: "-", country: "China" },
  { name: "Peking University", city: "Beijing", state: "-", country: "China" },
];

export default colleges;
